<template>
  <v-navigation-drawer
    :value="menuOpen"
    @input="(newValue) => $store.commit('MainTemplate/setMenuOpen', newValue)"
    color="grey lighten-5"
    app
  >
    <v-list-item class="px-2 py-5">
      <v-list-item-content>
        <v-list-item-title class="d-flex justify-center" id="menu.logo">
          <router-link :to="{ name: 'home' }">
            <img src="/img/logo.png" class="mb-5" width="100" />
          </router-link>
        </v-list-item-title>

        <v-list-item-subtitle class="d-flex justify-center" id="menu.ano_selector">
          <e-ano-selector class="" />
          <!-- <e-franquia-selector class="ml-2" /> -->
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list dense>
      <v-list-group
        v-for="item in menu.items.filter(
          (item) =>
            item.exibir && item.children.filter((child) => canAccessMenuChild(child)).length > 0
        )"
        :key="item.title"
        v-model="item.active"
        no-action
        :append-icon="item.children && item.children.length > 0 ? undefined : ''"
        :prepend-icon="item.icon"
        @click="() => (item.to ? $router.push(item.to) : undefined)"
      >
        <template v-slot:activator>
          <!-- <v-list-item
                :to="item.to || undefined"
                link
              > -->
          <v-list-item-content>
            <v-list-item-title :id="item.id" v-text="item.title" />
          </v-list-item-content>
        </template>
        <v-list-item
          v-for="child in item.children"
          v-show="canAccessMenuChild(child)"
          :key="child.title"
          :to="child.to"
          :href="child.href"
          :target="child.target"
        >
          <v-divider v-if="child.type === 'spacer'" />
          <v-list-item-content v-if="child.type !== 'spacer'">
            <v-list-item-title :id="child.id" v-text="child.title" />
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
    <!-- </v-list-group> -->
    <!-- </v-list> -->
    <template v-slot:append>
      <e-situacao-caixa v-if="exibirFinanceiro" />
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
import EAnoSelector from "@/Pages/Templates/components/EAnoSelector.vue";
import ESituacaoCaixa from "@/Pages/Templates/components/ESituacaoCaixa.vue";

const exibirFinanceiro = process.env.VUE_APP_ATIVAR_FINANCEIRO === "true";
export default {
  name: "MainTemplate",
  components: {
    EAnoSelector,
    ESituacaoCaixa,
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    ...mapGetters("Franquias", ["franquias"]),
    ...mapGetters("MainTemplate", ["menuOpen"]),
    menu() {
      return {
        items: [
          {
            icon: "mdi mdi-home",
            title: "Início",
            id: "menu.inicio",
            exibir: true,
            children: [
              {
                title: "Ir para Início",
                id: "menu.ir_para_inicio",
                to:
                  (this.user ? this.user.roleName : "") === "professor"
                    ? {
                        name: "acessoProfessor.home",
                      }
                    : {
                        name:
                          (this.user ? this.user.roleName : "") === "prof-auxiliar"
                            ? "acessoProfessor.home"
                            : "home",
                      },
                icon: "",
              },
              {
                title: "Ir para notifiq",
                id: "menu.ir_para_notifiq",
                to: {
                  name: "notifiq.index",
                },
                permissions: ["notifiq.load"],
                icon: "",
              },
            ],
          },
          {
            icon: "mdi mdi-book-education",
            title: "Agenda",
            id: "menu.agenda",
            exibir: (this.user ? this.user.roleName : "") === "aluno",
            children: [
              {
                title: "Ir para Agendas",
                id: "menu.ir_para_agendas",
                to: {
                  name: "agenda.aluno",
                },
                icon: "",
              },
            ],
          },
          {
            icon: "mdi mdi-comment-alert",
            title: "Avisos",
            id: "menu.avisos",
            exibir: true,
            permissions: ["alunos.detalhes"],
            children: [
              // {
              //   title: "Meus avisos",
              //   to: {
              //     name: "avisos.portal",
              //   },
              //   icon: "",
              // },
              {
                title: "Ir para Avisos",
                id: "menu.ir_para_avisos",
                to: {
                  name:
                    (this.user ? this.user.roleName : "") === "aluno"
                      ? "avisos.portal"
                      : "avisos.index",
                },
                permissions: ["avisos.*", "avisos.listar", "alunos.detalhes"],
                icon: "",
              },
            ],
          },
          {
            icon: "mdi mdi-account-school",
            title: "Matrículas",
            id: "menu.matriculas",
            exibir: true,
            children: [
              {
                title: "Ver Matrículas",
                id: "menu.ver_matriculas",
                to: { name: "matriculas" },
                permissions: ["matriculas.matricular", "matriculas.*"],
                icon: "",
              },
              // { title: "Adicionar matricula", to: "#", icon: "" },
              {
                title: "Ver Alunos",
                id: "menu.ver_alunos",
                to: { name: "alunos" },
                permissions: ["alunos.criarAluno", "alunos.*"],
                icon: "",
              },
              {
                title: "Pesquisa avançada",
                id: "menu.pesquisa_avancada",
                to: { name: "alunos-pesquisa-avancada" },
                permissions: ["alunos.criarAluno", "alunos.*"],
                icon: "",
              },
            ],
          },
          {
            icon: "mdi mdi-school",
            title: "Turmas",
            id: "menu.turmas",
            exibir: true,
            children: [
              {
                title: "Ver turmas",
                id: "menu.ver_turmas",
                to: { name: "turmas" },
                permissions: ["turmas.criarTurma", "turmas.*"],
                icon: "",
              },
              {
                title: "Gestão de Etapas",
                id: "menu.gestao_anos",
                to: { name: "series" },
                icon: "fa fa-bookmark",
                permissions: ["series.*", "series.criar"],
              },
              {
                title: "Gestão de disciplinas",
                id: "menu.gestao_disciplinas",
                to: { name: "disciplinas" },
                icon: "fa fa-bookmark",
                permissions: ["disciplinas.*", "disciplinas.criarDisciplina"],
              },
            ],
          },
          {
            icon: "mdi mdi-note-text",
            title: "Planos",
            id: "menu.planos",
            exibir: true,
            children: [
              {
                title: "Listar planos",
                id: "menu.listar_planos",
                to: { name: "gestoesDeAulas.planos" },
                icon: "",
                permissions: ["planosBimestrais.aprovar"],
              },
              {
                title: "Listar planos infantis",
                id: "menu.listar_planos_infantis",
                to: { name: "gestoesDeAulas.planosInfantil" },
                icon: "",
                permissions: ["planosBimestrais.aprovar"],
              },
              {
                title: "Gerenciar planos",
                id: "menu.gerenciar_planos",
                to: { name: "gerenciarPlanos" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.criar"],
              },
              {
                title: "Planejamento de Aulas",
                id: "menu.planejamento_de_aulas",
                to: { name: "gestoesDeAulas.planejametoDeAulas" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.criar"],
              },
              {
                title: "Códigos e Habilidades",
                id: "menu.codigos_e_habilidades",
                to: { name: "codigosHabilidades.index" },
                icon: "",
                permissions: ["codigosHabilidades.*", "codigosHabilidades.listar"],
              },
              {
                title: "Descritores",
                id: "menu.descritores",
                to: { name: "descritores.index" },
                icon: "",
                permissions: ["descritores.*", "descritores.listar"],
              },
            ],
          },
          {
            icon: "mdi-human-male-board-poll",
            title: "Diário online",
            id: "menu.diario_online",
            exibir: true,
            children: [
              {
                title: "Listar todos",
                id: "menu.diario_online.listar_todos",
                to: { name: "gestoesDeAulas" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.criar", "gestoesDeAulas.listar"],
              },
              {
                title: "Gestão geral",
                id: "menu.diario_online.gestao_geral",
                to: { name: "gestoesDeAulas.geral" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.gestoesGeral"],
              },
              {
                title: "Agendas",
                id: "menu.diario_online.agendas",
                to: { name: "agenda.index" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.listar"],
              },
            ],
          },
          {
            icon: "mdi mdi-human-male-board",
            title: "Diário de CAEE",
            id: "gestoesDeAtendimentosCAEE.menuBtn",
            exibir: true,
            children: [
              {
                title: "Listar todos",
                id: "gestoesDeAtendimentosCAEE.listarBtn",
                to: { name: "gestoesDeAulasCAEE" },
                icon: "",
                permissions: [
                  "*",
                  "gestoesDeAulasCAEE.*",
                  "gestoesDeAulasCAEE.criar",
                  "gestoesDeAulasCAEE.visualizar",
                ],
              },
            ],
          },
          {
            icon: "mdi-human-male-board",
            title: "Diário de Auxiliares",
            id: "menu.diario_auxiliares",
            exibir: true,
            children: [
              {
                title: "Listar todos",
                id: "menu.diario_auxiliares.listar_todos",
                to: { name: "gestoesDeAulasAuxiliares" },
                icon: "",
                permissions: [
                  "gestoesDeAulasAuxiliares.*",
                  "gestoesDeAulasAuxiliares.criar",
                  "gestoesDeAulasAuxiliares.listar",
                ],
              },
            ],
          },

          {
            icon: "mdi mdi-chart-box",
            title: "Relatórios",
            id: "menu.relatorios",
            exibir: true,
            children: [
              {
                title: "Ver todos",
                id: "menu.ver_todos_relatorios",
                to: {
                  name: `relatorios`,
                  params: { franquiaId: this.user.franquia?.id },
                },
                icon: "",
                permissions: ["relatorios.*"],
              },
            ],
          },
          {
            icon: "mdi mdi-account-switch",
            title: "Usuários",
            id: "menu.usuarios",
            exibir: true,
            children: [
              {
                title: "Ver Professores",
                id: "menu.ver_professores",
                to: { name: "professores" },
                icon: "fa fa-user-tie",
                permissions: ["users.*"],
              },
              {
                title: "Bloqueios/Liberações",
                id: "menu.bloqueios_liberacoes",
                to: { name: "usuarios.listaDeUsuariosParaBloquearLiberar" },
                icon: "fa fa-bookmark",
                permissions: ["users.*"],
                exibir: this.user?.id === 943 || this.user.roleName === "super-admin", // só aparece para o usuário tec Djacilene Xavier
              },
              {
                title: "Outros",
                id: "menu.outros_usuarios",
                to: { name: "usuarios" },
                icon: "fa fa-bookmark",
                permissions: ["users.*"],
              },
            ],
          },
          {
            icon: "mdi mdi-cash-multiple",
            title: "Financeiro",
            id: "menu.financeiro",
            exibir: exibirFinanceiro,
            children: [
              {
                title: "Mensalidades",
                id: "menu.mensalidades",
                to: { name: "mensalidades" },
                permissions: "financeiro.baixarParcela",
                icon: "",
              },
              {
                title: "Gestão de Caixas",
                id: "menu.gestao_caixas",
                to: { name: "caixas" },
                permissions: "caixas.abrir",
                icon: "",
              },
            ],
          },
          {
            icon: "mdi mdi-account-network",
            title: "Administração",
            id: "menu.administracao",
            exibir: true,
            children: [
              {
                title: "Franquias",
                id: "menu.franquias",
                to: { name: "franquias" },
                permissions: ["franquias.*", "franquias.criarFranquia"],
                icon: "",
              },
              {
                title: "Circuito De Notas",
                id: "menu.circuito_notas",
                to: { name: "circuito-notas" },
                permissions: ["circuitoNotas.*"],
                icon: "",
              },
              {
                title: "Bolsa Família",
                id: "menu.bolsa_familia",
                to: { name: "bolsa-familia" },
                permissions: ["circuitoNotas.*"],
                icon: "",
              },
              {
                title: "Calculadora FUNDEB",
                id: "menu.calculadora_fundeb",
                to: { name: "fundeb.calculadora" },
                permissions: ["calculadoraFundeb.*"],
                // exibir: this.user.roleName === "admin" || this.user.roleName === "super-admin",
                icon: "",
              },
            ],
          },
          {
            icon: "query_stats",
            title: "Desempenho Pedagógico",
            id: "menu.desempenho_pedagogico",
            exibir: true,
            children: [
              {
                title: "Desempenho Professor",
                id: "menu.desempenho_pedagogico.desempenho_professor",
                to: { name: "usabilidade.usabilidadeDoSistemaProfessor" },
                icon: "",
                permissions: ["desempenhoPedagogico.desempenhoProfessor"],
              },
              {
                title: "Desempenho Coordenador",
                id: "menu.desempenho_pedagogico.desempenho_coordenador",
                to: { name: "usabilidade.usabilidadeDoSistemaCoordenador" },
                icon: "",
                permissions: ["desempenhoPedagogico.desempenhoCoordenador"],
              },
              {
                title: "Pendências",
                id: "menu.desempenho_pedagogico.pendencias",
                to: { name: "gestoesDeAulas.pendencias" },
                icon: "",
                permissions: ["gestoesDeAulas.pendencias"],
              },
            ],
          },
          {
            icon: "mdi mdi-calendar-check", // Ícone para o item principal
            title: "Calendário Letivo",
            id: "menu.calendario_letivo",
            exibir: true,
            children: [
              {
                title: "Calendário",
                id: "menu.calendario_letivo.calendario",
                to: { name: "calendario-letivo.create" },
                permissions: ["calendarioLetivo.*", "calendarioLetivo.calendariosIndex"],
                icon: "",
              },
              {
                title: "Adicionar Categoria",
                id: "menu.calendario_letivo.adicionar_categoria",
                to: { name: "eventos-calendario-letivo" },
                permissions: ["calendarioLetivo.*", "eventosCalendarioLetivo.eventosCreate"],
                icon: "",
              },
            ],
          },
          {
            icon: "mdi-bell-ring",
            title: "Notifiq",
            id: "menu.notifiq",
            exibir: true,
            children: [
              {
                title: "Presença no Notifiq",
                to: { name: "notifiq.indexNotifiq" },
                permissions: ["notifiq.listaPresencasNotifiq"],
              },
            ],
          },
          {
            icon: "mdi mdi-clock-outline",
            title: "Folha de Pontos",
            id: "menu.folha_de_pontos",
            exibir: true,
            children: [
              // {
              //   title: "Meus horários",
              //   to: { name: "instrutores.meusHorarios" },
              //   exibir: this.canAccessOwnScheduleModule(),
              //   permissions: ["instrutores.meusHorarios"],
              // },
              {
                title: "Meus Pontos",
                id: "menu.folha_de_pontos.meus_pontos",
                to: { name: "colaboradores.meusPontos" },
                exibir: this.canAccessColaboradorModule(),
                permissions: ["colaboradores.meusPontos"],
              },
              {
                title: "Ponto dos Colaboradores",
                id: "menu.folha_de_pontos.ponto_dos_colaboradores",
                to: { name: "colaboradores.pontos" },
                exibir: ["admin", "super-admin"].includes(this.user?.roleName),
                permissions: ["colaboradores.pontos"],
              },
              {
                title: "Justificativas",
                id: "menu.folha_de_pontos.justificativas",
                to: { name: "colaboradores.faltasJustificadas" },
                exibir: this.canAccessColaboradorModule(),
                permissions: ["colaboradores.faltasJustificadas.solicitar"],
              },
              {
                title: "Gerenciar Faltas",
                id: "menu.folha_de_pontos.gerenciar_faltas",
                to: { name: "colaboradores.faltasJustificadas.gerenciar" },
                exibir: ["admin", "super-admin", "coordenador"].includes(this.user?.roleName),
                permissions: ["colaboradores.faltasJustificadas.gerenciar"],
              },
              {
                title: "Feriados",
                id: "menu.folha_de_pontos.feriados",
                to: { name: "feriados.gerenciar" },
                permissions: ["feriados.gerenciar"],
              },
              {
                title: "Justificativa em Massa",
                id: "menu.folha_de_pontos.justificativa_em_massa",
                to: { name: "colaboradores.justificativaMassa" },
                exibir: this.canAccessGestorModule(),
                permissions: ["colaboradores.justificativaMassa"],
              },
            ],
          },
          {
            icon: "mdi mdi-help",
            title: "Ajuda e tutorial",
            id: "menu.ajuda_tutorial",
            exibir: true,
            children: [
              {
                title: "Tutoriais",
                id: "menu.tutoriais",
                href: "https://epublic.tawk.help/",
                target: "_blank",
              },
            ],
          },
        ],
        width: "250px",
      };
    },
  },
  mounted() {
    // this.$Tawk.$setOnLoadFunction(() => this.$Tawk.$showWidget());
  },
  data() {
    return {
      selectedItem: 0,
      openAtualizarSenhaModal: false,
      openSelecionarFranquiaModal: false,
      exibirFinanceiro,
    };
  },
  methods: {
    canAccessMenuChild(child) {
      if (child.exibir === false) return false;
      if (this.user?.roleName === "super-admin") return true;
      return this.$can(child.permissions);
    },
    canAccessOwnScheduleModule() {
      const allowedRoles = ["TI", "admin", "super-admin", "professor"];
      console.log("User:", this.user?.roleName, "Instrutor ID:", this.user?.instrutor?.id);
      console.log(allowedRoles.includes(this.user?.roleName) && Boolean(this.user?.instrutor?.id));

      return allowedRoles.includes(this.user?.roleName) && Boolean(this.user?.instrutor?.id);
    },
    canAccessInstructorAdminScheduleModule() {
      const allowedRoles = ["TI", "admin", "super-admin"];
      return allowedRoles.includes(this.user?.roleName);
    },
    canAccessColaboradorModule() {
      const allowedRoles = [
        "professor",
        "prof-auxiliar",
        "secretario-escolar",
        "coordenador",
        "direção",
      ];
      return allowedRoles.includes(this.user?.roleName);
    },
    canAccessGestorModule() {
      const allowedRoles = ["TI", "admin", "super-admin", "coordenador", "direção"];
      return allowedRoles.includes(this.user?.roleName);
    },
    toggleMenu() {
      this.$store.commit("MainTemplate/setMenuOpen", !this.menuOpen);
    },
  },
};
</script>
